import React from 'react';
import { UploadOutlined, EditOutlined, DeleteOutlined, CopyOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { useDictionaryTranslation } from '../../../../hooks/useDictionaryTranslation';
import { ActionItem, ContentActions } from '../../../IncidentTypes/components/Styles';

export const CustomListTableActions = ({
  deleteItemList,
  editCustomListItem,
  openImportListModal,
  duplicateToAccount,
  showDuplicate,
}) => {
  const { translate: t } = useDictionaryTranslation();

  return (
    <ContentActions>
      <li>
        <ActionItem onClick={openImportListModal}>
          <UploadOutlined />
          <span>{t('import')}</span>
        </ActionItem>
      </li>

      <li>
        <ActionItem onClick={editCustomListItem}>
          <EditOutlined />
          <span>{t('edit')}</span>
        </ActionItem>
      </li>

      {showDuplicate && (
        <li>
          <ActionItem onClick={duplicateToAccount}>
            <CopyOutlined />
            <span>{t('duplicateInAnotherAccount')}</span>
          </ActionItem>
        </li>
      )}

      <li>
        <ActionItem onClick={deleteItemList}>
          <DeleteOutlined />
          <span>{t('delete')}</span>
        </ActionItem>
      </li>
    </ContentActions>

  )
}

CustomListTableActions.propTypes = {
  deleteItemList: PropTypes.func,
  editCustomListItem: PropTypes.func,
  openImportListModal: PropTypes.func,
  duplicateToAccount: PropTypes.func,
  showDuplicate: PropTypes.bool,
};